<template>

  <div id="app">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs4 sm4>
              <v-card class="elevation-12">
                <v-layout row>
                  <!-- formulario -->
                  <v-flex xs12 sm12 py-3 px-3>
                    <v-form ref="form" lazy-validation>
                      <v-card-text>
                        <v-form>
                          <v-flex py-2>
                            <div class="data-title data-colorcorp1">{{ this.$t('cambioEstilo') }}</div>
                          </v-flex>
                          <div class="data-colorcorp1">
                            <v-select :items="items" prepend-icon="palette" :label="$t('cliente')" item-text="label"
                              item-value="codigo" v-model="clienteSelected"></v-select>
                          </div>
                        </v-form>
                      </v-card-text>
                      <v-spacer> </v-spacer>
                      <div>
                        <v-btn class="data-bntStandard data-bgGreyDark" @click="aplicarCambio()">
                          <v-flex px-4>
                            <div class="white--text">{{ this.$t('aplicar') }}</div>
                          </v-flex>
                        </v-btn>
                      </div>
                    </v-form>
                  </v-flex>
                </v-layout>
                <v-spacer></v-spacer>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>

    </v-app>
  </div>

</template>

<script>

export default {
  name: 'ShpInitStyle',
  components: {
  },
  data() {
    return {
      clienteSelected: null,
      items: [
        { codigo: 'lulu', label: 'Base' },
        { codigo: 'sonibetica', label: 'Sonibetica' },
        { codigo: 'viso', label: 'Jimenez Viso' },
        { codigo: 'spazia', label: 'Spazia' }
      ]
    }
  },
  created() {
  },
  methods: {
    /*
     * valida la sesión
     */
    aplicarCambio() {
      // Limpia la cache
      this.$store.commit('removeAutenticacion')
      this.$store.commit('removeEstilo')

      const datosEstilo = { "path": this.clienteSelected }
      this.$store.commit('setEstilo', datosEstilo)
      localStorage.setItem('datos-estilo', JSON.stringify(datosEstilo))

      // redirige a la pagina de login
      // this.$router.push({name: 'ShpLogin'})
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/ShpInitStyle.vue